export const MOVE_BRASIL_STEPS = [
	{
		title: "Cadastro e consentimento",
		description:
			"Cadastro na plataforma gov.br. Motorista autoriza avaliação dos seus dados.",
		boldParts: ["gov.br"] as const,
	},
	{
		title: "Confirmação",
		description:
			"Em até 5 dias úteis por WhatsApp e caixa portal com elegibilidade ou não.",
		boldParts: ["5 dias úteis"] as const,
	},
	{
		title: "Solicitação de financiamento",
		description:
			"Com confirmação em mãos, busque o banco para análise.",
		boldParts: ["para análise."] as const,
	},
] as const;

export const MOVE_BRASIL_STEPS_START_DATE = "19 de junho.";
